import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useActivityContext } from '../index';
import { API_CONFIG } from '../../../../../config/api';

const PartFPage2 = () => {
  const { activity } = useActivityContext();
  const [skills, setSkills] = useState(
    Array(4).fill(null).map(() => ({ skill_name: '', hours: 0, pursuing: false, completed: false }))
  );
  const [saving, setSaving] = useState(false);
  const [saveMessage, setSaveMessage] = useState('');

  const saveTimeoutRef = useRef(null);

  useEffect(() => {
    if (activity?.my_response_part_f?.page_2?.skills) {
      const savedSkills = activity.my_response_part_f.page_2.skills;
      const paddedSkills = [...savedSkills];
      while (paddedSkills.length < 4) {
        paddedSkills.push({ skill_name: '', hours: 0, pursuing: false, completed: false });
      }
      setSkills(paddedSkills.slice(0, 4));
    }
  }, [activity]);

  const saveChanges = async (updatedSkills) => {
    try {
      setSaving(true);
      const token = localStorage.getItem('accessToken');
      const apiUrl = API_CONFIG.BASE_URL;

      await axios.put(
        `${apiUrl}/secondary/user/domain-activities/${activity.activity_id}/part-f/page-2/student-fields`,
        { skills: updatedSkills },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setSaveMessage('Saved ✓');
      setTimeout(() => setSaveMessage(''), 2000);
    } catch (error) {
      console.error('Error saving:', error);
      setSaveMessage('Error saving');
      setTimeout(() => setSaveMessage(''), 3000);
    } finally {
      setSaving(false);
    }
  };

  const handleSkillChange = (index, field, value) => {
    const updatedSkills = [...skills];
    updatedSkills[index] = {
      ...updatedSkills[index],
      [field]: field === 'hours' ? parseInt(value) || 0 : value
    };
    setSkills(updatedSkills);

    if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
    saveTimeoutRef.current = setTimeout(() => saveChanges(updatedSkills), 1000);
  };

  const getTotalHours = () => {
    return skills.reduce((sum, skill) => sum + (skill.hours || 0), 0);
  };

  const rowLabels = ['a', 'b', 'c', 'd'];

  return (
    <div style={{
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '40px',
      backgroundColor: 'white',
      fontFamily: "'Poppins', Arial, sans-serif",
      position: 'relative',
      boxSizing: 'border-box',
      minHeight: '500px'
    }}>
      {/* Save Indicator */}
      {saveMessage && (
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          backgroundColor: saving ? '#FFC107' : '#4CAF50',
          color: saving ? 'black' : 'white',
          padding: '10px 20px',
          borderRadius: '4px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          zIndex: 1000,
          fontWeight: 'bold'
        }}>
          {saveMessage}
        </div>
      )}

      {/* Top-right orange corner */}
      

      {/* Section 4: Learning in the Community (Skill Training) */}
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        border: '2px solid #888',
        marginBottom: '40px'
      }}>
        <thead>
          <tr style={{ backgroundColor: '#F4CD8A' }}>
            <th colSpan={5} style={{
              padding: '12px 10px',
              textAlign: 'left',
              fontWeight: 'bold',
              fontSize: '14px',
              color: '#333',
              border: '1px solid #888'
            }}>
              4. Learning in the Community (Skill Training)
            </th>
          </tr>
          <tr style={{ backgroundColor: '#F4E4B8' }}>
            <th style={{
              width: '60px',
              padding: '10px',
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 'normal',
              color: '#333',
              border: '1px solid #888',
              backgroundColor: '#FFF9E6'
            }}></th>
            <th style={{
              padding: '10px',
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#333',
              border: '1px solid #888'
            }}>
              Skill
            </th>
            <th style={{
              width: '150px',
              padding: '10px',
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#333',
              border: '1px solid #888'
            }}>
              Number of Hours
            </th>
            <th style={{
              width: '120px',
              padding: '10px',
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#333',
              border: '1px solid #888'
            }}>
              Pursuing
            </th>
            <th style={{
              width: '120px',
              padding: '10px',
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#333',
              border: '1px solid #888'
            }}>
              Completed (✓)
            </th>
          </tr>
        </thead>
        <tbody>
          {skills.map((skill, index) => (
            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#FFFEF8' : '#FFF9E6' }}>
              <td style={{
                padding: '10px',
                textAlign: 'center',
                fontSize: '14px',
                color: '#333',
                border: '1px solid #888',
                fontWeight: 'bold'
              }}>
                {rowLabels[index]})
              </td>
              <td style={{
                padding: '0',
                border: '1px solid #888'
              }}>
                <input
                  type="text"
                  value={skill.skill_name}
                  onChange={(e) => handleSkillChange(index, 'skill_name', e.target.value)}
                  placeholder="Enter skill name..."
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: 'none',
                    backgroundColor: 'transparent',
                    fontSize: '14px',
                    color: '#333',
                    outline: 'none'
                  }}
                />
              </td>
              <td style={{
                padding: '0',
                border: '1px solid #888',
                textAlign: 'center'
              }}>
                <input
                  type="number"
                  min="0"
                  value={skill.hours || ''}
                  onChange={(e) => handleSkillChange(index, 'hours', e.target.value)}
                  placeholder="0"
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: 'none',
                    backgroundColor: 'transparent',
                    fontSize: '14px',
                    color: '#333',
                    textAlign: 'center',
                    outline: 'none'
                  }}
                />
              </td>
              <td style={{
                padding: '10px',
                border: '1px solid #888',
                textAlign: 'center'
              }}>
                <input
                  type="checkbox"
                  checked={skill.pursuing}
                  onChange={(e) => handleSkillChange(index, 'pursuing', e.target.checked)}
                  style={{
                    width: '18px',
                    height: '18px',
                    cursor: 'pointer'
                  }}
                />
              </td>
              <td style={{
                padding: '10px',
                border: '1px solid #888',
                textAlign: 'center'
              }}>
                <input
                  type="checkbox"
                  checked={skill.completed}
                  onChange={(e) => handleSkillChange(index, 'completed', e.target.checked)}
                  style={{
                    width: '18px',
                    height: '18px',
                    cursor: 'pointer'
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr style={{ backgroundColor: '#F4E4B8' }}>
            <td style={{
              padding: '12px',
              border: '1px solid #888'
            }}></td>
            <td style={{
              padding: '12px',
              textAlign: 'right',
              fontWeight: 'bold',
              fontSize: '16px',
              color: '#333',
              border: '1px solid #888'
            }}>
              Total Hours
            </td>
            <td style={{
              padding: '12px',
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '16px',
              color: '#333',
              border: '1px solid #888'
            }}>
              {getTotalHours()}
            </td>
            <td style={{
              padding: '12px',
              border: '1px solid #888'
            }}></td>
            <td style={{
              padding: '12px',
              border: '1px solid #888'
            }}></td>
          </tr>
        </tfoot>
      </table>

      {/* Page Number */}
      <div style={{
        textAlign: 'center',
        fontSize: '14px',
        color: '#666',
        fontWeight: 'bold',
        marginTop: '30px'
      }}>
        40
      </div>

      {/* Bottom-left orange corner */}
      

      {/* Bottom-right decorative corner */}
      
    </div>
  );
};

export default PartFPage2;
